import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { getServiceWorkerRegistration, registerServiceWorker } from './pushServiceWorkerUtils';

const usePushNotifications = () => {
  const { generalApiCall } = useGeneralApiCall();

  const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  };

  const subscribePushNotifications = async () => {
    try {
      if (!('PushManager' in window) || !('Notification' in window)) return;
      if (Notification.permission !== 'granted') return;

      const reg = await registerServiceWorker();
      if (!reg) return;

      const existing = await reg.pushManager.getSubscription();
      let sub = existing;
      if (!existing) {
        const publicKeyRes = await generalApiCall({
          pathname: '/api/push-subscriptions/vapid-public-key',
          method: 'get',
          notShowErrorMessage: true,
        });
        const { publicKey } = publicKeyRes;
        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicKey),
        });
      }

      const p256dh = btoa(String.fromCharCode(...new Uint8Array(sub.getKey('p256dh'))));
      const auth = btoa(String.fromCharCode(...new Uint8Array(sub.getKey('auth'))));

      await generalApiCall({
        pathname: '/api/push-subscriptions',
        method: 'post',
        needsAuthentication: true,
        requestProperties: { endpoint: sub.endpoint, p256dh, auth },
        notShowErrorMessage: true,
      });
    } catch (error) {
      console.error('subscribePushNotifications error:', error);
    }
  };

  const unsubscribePushNotifications = async () => {
    try {
      const reg = await getServiceWorkerRegistration();
      const sub = await reg?.pushManager.getSubscription();
      if (!sub) return;

      await generalApiCall({
        pathname: '/api/push-subscriptions',
        method: 'delete',
        needsAuthentication: true,
        requestProperties: { endpoint: sub.endpoint },
        notShowErrorMessage: true,
      });

      await sub.unsubscribe();
    } catch (error) {}
  };

  return { subscribePushNotifications, unsubscribePushNotifications };
};

export default usePushNotifications;
